import React, { useState, useRef, useEffect, useContext } from "react";
import { useHistory, NavLink } from "react-router-dom";
import { Button, Grid, Modal, Icon } from 'semantic-ui-react'
import { toast } from 'react-toastify';
import moment from "moment";
import {isMobile} from 'react-device-detect';
import "./PaymentScreen.scss";
import { Input } from "semantic-ui-react";
import atar_logo from "../../assets/home/atar_logo.png";
import visa from "../../assets/home/visa.svg";
import visa2 from "../../assets/home/visa2.svg";
import phonepe from "../../assets/home/phonepe.svg";
import paytm from "../../assets/home/paytm-1.svg";
import googlepay from "../../assets/home/google-pay.svg";
import Shape from "../../assets/home/MobiKwik.svg";
import success from "../../assets/home/checked.svg";
import wrong from "../../assets/home/close-icon.svg";
import close from "../../assets/home/close.svg";
import { Config } from "../../common"
import { useSelector, useDispatch } from 'react-redux'
import { validatePromo, createOrder, verifyOrder, clearPaymentInfo, clearPromo, listAllPromos } from '../../store/TriviaRedux'
import { useTranslation } from "react-i18next";
import { StarButton } from '../../components'

function loadScript(src) {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
}

const Payment = () => {
  const dispatch = useDispatch()
  const pageActive = useRef(false);
  const token = useSelector((state) => state.auth.token)
  const triviaInfo = useSelector((state) => state.trivia.triviaInfo)
  const isFetching = useSelector((state) => state.trivia.isFetching)
  const verifyPromo = useSelector((state) => state.trivia.verifyPromo)
  const messagePromo = useSelector((state) => state.trivia.errorPromo)
  const razorpayorderID = useSelector((state) => state.trivia.razorpayorderID)
  const verifyOrderSucces = useSelector((state) => state.trivia.verifyOrderSucces)
  const offerList = useSelector((state) => state.trivia.offerList)
  const history = useHistory();
  const [promoCodelist, setPromoCodeList] = useState(null);
  const [promoCode, setPromoCode] = useState(null);
  const [promeError, setPromeError] = useState(false);
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false)


  useEffect(() => {
    dispatch(clearPromo())
    if (triviaInfo) {
      dispatch(listAllPromos({ token, triviaID: triviaInfo._id }))
    }
    window.scrollTo(0, 0)
  }, []);

  useEffect(() => {
    if (razorpayorderID && pageActive.current) {
      displayRazorpay();
    }
  }, [razorpayorderID]);

  useEffect(() => {
    if (verifyOrderSucces && verifyOrderSucces === true) {
      // alert("This step of Payment Succeeded");
      toast.success("This step of Payment Succeeded");
      dispatch(clearPaymentInfo())
      history.push("/beforecontestgiftcard");
    }
    if (verifyOrderSucces && verifyOrderSucces === false) {
      dispatch(clearPaymentInfo())
      alert("Verification failed");
    }
  }, [verifyOrderSucces]);


  const checkPromoCode = (value) => {
    if (promoCode || value) {
      let params = {
        promo: value ? value : promoCode,
        triviaId: triviaInfo._id,
      };
      params.token = token
      dispatch(validatePromo(params))
    } else {
      setPromeError(true);
    }
  };

  const payment = () => {
    if (verifyPromo) {
      var params = {
        triviaId: triviaInfo._id,
        promo: promoCode,
      };
    } else {
      var params = {
        triviaId: triviaInfo._id,
      };
    }
    params.token = token
    params.device = isMobile ? 'webapp' : 'website'
    pageActive.current = true
    dispatch(createOrder(params))
  };


  async function displayRazorpay() {
    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }

    var options = {
      description: 'Lorem Ipsum is simply',
      image: 'https://media.geeksforgeeks.org/wp-content/uploads/20210806114908/dummy-200x200.png',
      currency: 'INR',
      key: 'rzp_test_d8LpIEdB9Nu3KS', // Your api key
      amount: Number(triviaInfo?.entryFee - discountAmt),
      name: 'Insta Startzz',
      order_id: razorpayorderID,
      handler: function (response) {
        let params = {
          paymentID: response.razorpay_payment_id,
          razorpayOrderID: razorpayorderID,
        };
        params.token = token
        params.razorPaySignature = response.razorpay_signature
        dispatch(verifyOrder(params))
      },
      prefill: {
        //Here we are prefilling random contact
        contact: "9876543210",
        //name and email id, so while checkout
        name: "Twinkle Sharma",
        email: "smtwinkle@gmail.com",
      },
      notes: {
        description: "Best Course for SDE placements",
        language:
          "Available in 4 major Languages JAVA,C/C++, Python, Javascript",
        access: "This course have Lifetime Access",
      },
      theme: {
        color: "#2300a3",
      },
    };
    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  }

  let basicDetails = Config.GetLanguage(triviaInfo, i18n.language, 'basicDetails')
  let title = basicDetails?.title ? basicDetails?.title : null
  let discountAmt = verifyPromo ? parseInt(triviaInfo?.entryFee * Number(verifyPromo.discount / 100)) : 0
  return (
    <>
      <div className="container-fluid bg clearall">
        <div className="giftcardbg">
          <NavLink
            to="">
            <img className="giftcar_logo" src={atar_logo} />
          </NavLink>

          <div className="pay">PAYMENT</div>

          <div className="sarukhan">
            <img className="sarukhan1_img" src={triviaInfo.mobileImage} />
            <img className="sarukhan2_img" src={triviaInfo.mainContestListingMobileViewImage} />
            {title && (<h4>{(title).split(' ')[0]} <span> {title.substring(title.indexOf(" ") + 1, title.length)}</span></h4>)}
            {triviaInfo && (<h5>{basicDetails?.about}</h5>)}
          </div>

          {(verifyPromo || messagePromo) ? <div className="promo">
            <h5>Have a Promocode?</h5>

            <Grid className="Promo_Code">
              <Grid.Row>
                <Grid.Column mobile={3} tablet={8} computer={1}>
                  {messagePromo ?
                  <img src={wrong} className= "wrong-input-img" />
                   : <img src={success} />}
                </Grid.Column>
                <Grid.Column className="Applied" mobile={10} tablet={8} computer={12}
                >
                  {promoCode}
                  <p>{messagePromo ? 'Promo code is invalid!' : 'Promo code Successfully Applied!'}</p>
                </Grid.Column>
                <Grid.Column mobile={3} tablet={8} computer={3}>
                  <Button className="Promos_close" onClick={() => {
                    setPromoCodeList(null)
                    setPromoCode('')
                    setPromeError(null)
                    dispatch(clearPromo())
                  }}><i class="fa fa-times-circle" aria-hidden="true"></i></Button>
                </Grid.Column>
              </Grid.Row></Grid>

          </div> : <div className="promo">
            <h5>Have a Promocode?</h5>
            <Input
              action={{
                content: 'Apply now',
                onClick: () => checkPromoCode()
              }}
              className={promoCode ? 'active' : ''}
              onChange={(e) => setPromoCode(e.target.value)} fluid
              placeholder='Enter the promo code here'
            />
          </div>}


          <Grid className="promocodes_view">
            <Grid.Row>
              <Grid.Column mobile={16} tablet={8} computer={12}>
                <h4> Click on view promocodes to avail other discounts :</h4>
              </Grid.Column>

              <h5 onClick={() => setOpen(true)}>View Promocodes ( {offerList?.length} ) </h5>


            </Grid.Row></Grid>


          <div className="summary">
            <h3>Order Summary</h3>
            <div className="order_boder"></div>
            <div className="lorem_number">
              <h4>Entry Fee <span>₹ {triviaInfo?.entryFee}</span></h4>
            </div>
            {verifyPromo && (<div className="lorem_number">
              <h4>Discount Amt <span>₹ {verifyPromo?.finalAmount}</span></h4>
            </div>)}
            <div className="order_boder"></div>
            <div className="lorems_number">
              <h4>Amount to be paid<span>₹ {triviaInfo?.entryFee - (verifyPromo ? verifyPromo?.finalAmount : 0)}</span> </h4>
            </div>
          </div>

          <div className="pm_bt destops">

          <button   className="try cancel" onClick={()=> history.push('/contest')   }  >
            <h4>Cancel</h4>
          </button>

            <StarButton background={'mainBg'} isLoading={isFetching} title="Pay now" width='full' onClickAction={payment} />
          </div>

          <div className="payment_img">
            <h4>Our Payment Gateways</h4>

            <div className="wrapper_sec">
              <div className="scrolls-sec">
                <div className="online_pay">
                  <img className="paytm" src={visa2} />
                  <img className="paytm" src={phonepe} />
                  <img className="paytm" src={paytm} />
                  <img className="paytm" src={googlepay} />
                  <img className="paytm" src={Shape} />
                  <img className="paytm" src={visa} />
                  <img className="paytm" src={phonepe} />
                  <img className="paytm" src={paytm} />
                  <img className="paytm" src={googlepay} />
                  <img className="paytm" src={Shape} />
                  <img className="paytm" src={visa} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="procced_now mobiles">
          <StarButton background={'mainBg'} width={'350px'} title={t("payment.btn")} onClickAction={payment} />

          
        </div>
       
      </div>

      <Modal className="offer_sec "
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        open={open}
      >
        <div className="select_sec">
          <img onClick={() => { setPromoCodeList(promoCode); setOpen(false)}} src={close} name='x' size='large' />
          <h6>Select an <span>Offer</span></h6>
        </div>

        <Grid centered divided className="promo-offer-modal" >
          {offerList ? offerList.map((item, key) => <Grid.Column onClick={() => setPromoCodeList(item.code)} key={key} textAlign='center' className={(item.code == promoCode) ? "Valid" : "Valid ValidNone"} mobile={16} tablet={5} computer={4}   >
            {(item.code == promoCodelist) && (<div className="check_icon"   ><i class="fa fa-check-circle" aria-hidden="true"></i></div>) }
            <h5>{item.code}</h5>
            {item.discountAmtType == 'amount' && (<h6>Discount price : ₹ {item.discountValue}</h6>)}
            {item.discountAmtType == 'percentage' && (<h6>Discount : {item.discount}% upto ₹ {item.maxDiscount}</h6>)}
            <p>Valid till : {moment.utc(item.expiry).format('Do MMM YYYY')}</p>
          </Grid.Column>) : null}
        </Grid>

        <div className="try_pag">
          <button onClick={() => { setPromoCodeList(promoCode); setOpen(false)}} className="try">
            <h4>Don't apply</h4>
          </button>
          
          <div className="Return_to">
            <StarButton onClickAction={() => { setPromoCode(promoCodelist); setOpen(false); checkPromoCode(promoCodelist) }} background={'mainBg'} width="350px" title="Apply Promocode"  />
          </div>
        </div>
      </Modal>

    </>
  );
};

export default Payment
